import styles from './styles.module.scss';

const PlayButton = ({playPauseFunc}) => {

    const handleClick = (e) => {
      e.preventDefault();
      console.log("clicked");
      playPauseFunc();
    }

    return(
      <button aria-label="Play Video" onClick={handleClick} className={styles.videoBanner__play}>
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.75">
            <path fillRule="evenodd" clipRule="evenodd" d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM45.6475 33.9231C46.966 33.1506 46.966 31.2445 45.6475 30.4719L26.3197 19.147C24.9864 18.3658 23.3086 19.3273 23.3086 20.8726V43.5224C23.3086 45.0677 24.9864 46.0293 26.3197 45.248L45.6475 33.9231Z" fill="#F6F6F6"/>
          </g>
        </svg>
      </button>
    );
}

export default PlayButton;